import { render, staticRenderFns } from "./RTextField.vue?vue&type=template&id=927e3e82&scoped=true&"
import script from "./RTextField.vue?vue&type=script&lang=js&"
export * from "./RTextField.vue?vue&type=script&lang=js&"
import style0 from "./RTextField.vue?vue&type=style&index=0&id=927e3e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927e3e82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextField,VTextarea})
